import {get} from "lodash"
import {ApiListResponseResult} from "types/api"
import BaseService from "./Base"

class IntegrationsService extends BaseService {
    constructor() {
        super(process.env.REACT_APP_INTEGRATIONS)
    }
    async list(params = {}): Promise<ApiListResponseResult<any[]>> {
        const response = await this.post("/v1/errors/get", params)
        return get(response, "data", [])
    }
    async getQuickbooksLink(syncFrom: string): Promise<{url: string}> {
        const response = await this.post("/v1/intuit/getAuthUrl", {syncFrom})
        return get(response, "data.data", {url: ""})
    }
    async getQuickbooksStatus(): Promise<{url: string}> {
        const response: any = await this.post("/v1/intuit/status", {})
        return get(response, "data.data", {})
    }
    async toggleQuickbooksActive(active: boolean): Promise<{success: boolean}> {
        const response: any = await this.post("/v1/intuit/toggleActive", {active})
        return get(response, "data.data", {success: false})
    }
}

export default IntegrationsService
